import { Injectable } from "@angular/core";
import { Http, Headers } from "@angular/http";

import { ConfigService } from "@shared/utils/config.service";

import { BaseService } from "@core/services/base.service";

import { Observable } from "rxjs/Rx";
import * as moment from 'moment'

import {GetTotalClientesSemPrevisaoParametros, GetTotalPrevisaoLancamentos} from './vendas.service.models'

//import * as _ from 'lodash';

// Add the RxJS Observable operators we need in this app.
import "../../../rxjs-operators";

@Injectable()
export class VendasService extends BaseService {
  baseUrl: string = "";

  constructor(private http: Http, private configService: ConfigService) {
    super();
    this.baseUrl = configService.getApiURI();
  }

  authorizedHeaders(): Headers {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");

    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return headers;
  }

  getMeses(term: string = null): any[] {
    let items = getMockMeses();
    if (term) {
      items = items.filter(
        x => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
      );
    }
    return items;
  }

  getUltimos12Meses(): any[] {
    const actualDateMoment = moment().locale('pt-br');
    actualDateMoment.add(3, 'M');

    const meses = []

    for(let i=0; i<16; i++){
      meses.unshift({
        id:actualDateMoment.format('YYYYMM'),
        name:actualDateMoment.format('MMM YYYY')
      })

      actualDateMoment.subtract(1, 'M');
    }

    return meses;
  }

  getCodigos(term: string = null): any[] {
    let items = getMockCodigos();
    if (term) {
      items = items.filter(
        x => x.name.toLocaleLowerCase().indexOf(term.toLocaleLowerCase()) > -1
      );
    }
    return items;
  }

  salvarPrevisao(linha, idCliente, setor, prevVendaAtual): Observable<any[]> {
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    let authToken = localStorage.getItem("auth_token");
    headers.append("Authorization", `Bearer ${authToken}`);

    return this.http
      .post(
        this.baseUrl + "/vendas/salvar",
        { linha, idCliente, setor, prevVendaAtual },
        { headers }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getTotalPrevisaoLancamentos(params: GetTotalPrevisaoLancamentos): Observable<number> {
    const headers: Headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/vendas/buscartotallancamento`,
        {
          headers,
          params
        }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }

  getTotalClientesSemPrevisao(params: GetTotalClientesSemPrevisaoParametros): Observable<number> {
    const headers = this.authorizedHeaders();

    return this.http
      .get(
        `${this.baseUrl}/vendas/buscartotalsemprevisao`,
        {
          headers,
          params
        }
      )
      .map(response => response.json())
      .catch(this.handleError);
  }
}

function getMockMeses() {
  return [
    { id: "1", name: "JANEIRO" },
    { id: "2", name: "FEVEREIRO" },
    { id: "3", name: "MARÇO" },
    { id: "4", name: "ABRIL" },
    { id: "5", name: "MAIO" },
    { id: "6", name: "JUNHO" },
    { id: "7", name: "JULHO" },
    { id: "8", name: "AGOSTO" },
    { id: "9", name: "SETEMBRO" },
    { id: "10", name: "OUTUBRO" },
    { id: "11", name: "NOVEMBRO" },
    { id: "12", name: "DEZEMBRO" }
  ];
}

function getMockCodigos() {
  return [
    { id: "AGUARDANDO MERCADO", name: "AGUARDANDO MERCADO" },
    { id: "COMPRA SUSPENSA", name: "COMPRA SUSPENSA" },
    { id: "REPROGRAMAR VISITA", name: "REPROGRAMAR VISITA" },
    { id: "CLIENTE AUSENTE", name: "CLIENTE AUSENTE" },
    { id: "FUTURO CLIENTE", name: "FUTURO CLIENTE" },
    { id: "CLIENTE ESTOCADO", name: "CLIENTE ESTOCADO" },
    {
      id: "LEVANTAMENTO DE ESTOQUE",
      name: "LEVANTAMENTO DE ESTOQUE"
    },
    { id: "PONTO DE VENDA", name: "PONTO DE VENDA" },
    { id: "FEITO COBRANÇA", name: "FEITO COBRANÇA" }
  ];
}
